import React, { useEffect, useState } from "react";
import Navbar from "../../Components/Navbar";
import { Bg, BoxContainer } from "../../Components/Styles/PageStyles";
import RichTextEditor from "../../Components/Settings/RichText";
import { useSelector } from "react-redux";
import { t } from "i18next";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import { useParams } from "react-router-dom";
import rentalAgreementTemplate from "../../Components/Template/rentalAgreementTemplate";
import { toast } from "react-toastify";

const RichText = () => {
  const { id, clientId } = useParams();
  const [htmlContent, setHtmlContent] = useState(rentalAgreementTemplate);
  const [fetchData, setFetchData] = useState();
  const user = useSelector((state) => state.UserReducer.user);
  const [apiData, setApiData] = useState();



  const fetchFunction = async () => {
    const body = new FormData();
    body.append("id", id);
    body.append("clientId", clientId);
    body.append("htmlContent", htmlContent);
 
    return await axios.post(`${Config.apiUrl}/createrentagreement`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const getRichTextSuccess = (data) => {
    if (data.data.status == "NOK" || data.data.data == false) {
      error = true;
      toast.success(data?.data?.msg || "Rent Agreement Updated successfully!");
    } else setFetchData(data.data.data);
    toast.success(data?.data?.msg || "Rent Agreement Updated successfully!");
      
  };

  const getRichTextError = (data) => { };

  const {
    isLoading: isLoadings,
    mutate: getRichTextMutate,
    error,
  } = useMutation(fetchFunction, {
    onSuccess: getRichTextSuccess,
    onError: getRichTextError,
  });
  const handleEditorChange = (content) => {
    setHtmlContent(content);

  }
  const handleSubmit = () => {
    console.log("Submitting content:", htmlContent);
    getRichTextMutate();
  };
  

  const rentagreementpdfFunction = async () => {
    if (clientId) {
      const body = new FormData();
      body.append("id", id);
      body.append("clientId", clientId);
      return axios.post(`${Config.apiUrl}/getrentagreementpdf`, body, {
        headers: {
          authorization: "Bearer " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      });
    }
  };

  const SuccessData = (data) => {
    if (data.data && data.data.data) {
      setApiData(data.data);
      setHtmlContent(data.data.data.rentalAgreementTemplate || data.data.data.content); 
       
    } else {
      console.error("Invalid API response structure:", data.data);
    }
  };
  const ErrorData = (data) => { };

  const {
   
    mutate: rentagreementpdfMutate,
  } = useMutation(rentagreementpdfFunction, {
    onSuccess: SuccessData,
    onError: ErrorData,
  });

  useEffect(() => {
    rentagreementpdfMutate();
  }, []);

  return (
    <>
      <Bg
        style={{
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />
        <BoxContainer>
          <div className="flex w-full justify-between items-center mb-4">
            <div>
              <Title>{t("Rich Text")}</Title>
              <Underline />
            </div>
          </div>

          <RichTextEditor
            value={htmlContent}
            onChange={handleEditorChange}
            onSave={handleSubmit}
            isLoadings={isLoadings}
          />
        </BoxContainer>
      </Bg>
    </>
  );
};

export default RichText;

const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
const Underline = tw.div`w-12 h-0.5 bg-gray-700 mt-1.5 rounded-full `;